// layouts/Dealer.js
import React from "react";
import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import DealerDashboard from "views/pages/dashboards/Dealer.js";
import { useKeycloak } from "variables/keycloak";

function Dealer() {
  const location = useLocation();
  const navigate = useNavigate();
  const mainContentRef = React.useRef(null);
  const keycloak = useKeycloak();
  // Scroll to top on route change
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContentRef.current) mainContentRef.current.scrollTop = 0;
  }, [location]);

  // Redirect to login if no user
  React.useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) navigate("/auth/login");
  }, [navigate]);

  const handleLogout = () => { 
    localStorage.removeItem('user');
    localStorage.removeItem('selectedSite');

    try {
      keycloak?.logout({
        redirectUri: `${window.location.origin}/auth/login`
      });
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <>
      {/* Navbar fixed at top */}
      <AdminNavbar theme="dark" onLogout={handleLogout} />

      {/* Main content area — add padding to clear navbar */}
      <div className="main-content" ref={mainContentRef} style={{ paddingTop: "5rem" }}>
        <Routes>
          <Route index element={<DealerDashboard />} />
          <Route path="dashboard" element={<DealerDashboard />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Routes>

        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
}

export default Dealer;
